module.exports = __webpack_public_path__ + "img/bg.8ce39153.png";